import script from "./nav-links.vue?vue&type=script&setup=true&lang=js"
export * from "./nav-links.vue?vue&type=script&setup=true&lang=js"

import "./nav-links.vue?vue&type=style&index=0&id=77388b8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77388b8a"]])

export default __exports__